import { render } from "./Snowflakes.vue?vue&type=template&id=57ea0642&scoped=true&ts=true"
import script from "./Snowflakes.vue?vue&type=script&lang=ts"
export * from "./Snowflakes.vue?vue&type=script&lang=ts"

import "./Snowflakes.vue?vue&type=style&index=0&id=57ea0642&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ea0642"]])

export default __exports__